import Home from "./views/Home.vue";
import { NotFound, NotAuthorized } from "@modernary/mui/components/common";
import { default as mapRoutes, mapRouteNames } from "./views/map/mapRoutes";

// Troubleshoot your routes using this - https://paths.esm.dev

export const routeNames = {
  home: "Home",
  notAuthorized: "NotAuthorized",
  ...mapRouteNames,
};

/** @type {import('vue-router').RouterOptions['routes']} */
export const routes = [
  { path: "/", component: Home, name: routeNames.home, meta: { title: "Home" } },
  {
    path: "/unauthorized",
    component: NotAuthorized,
    name: routeNames.notAuthorized,
    meta: { title: "Not Authorized" },
  },
  ...mapRoutes,
  { path: "/:path(.*)", component: NotFound },
];
